// extracted by mini-css-extract-plugin
export default {"cardContainer":"profile_cardContainer__8LO9Z","showCard":"profile_showCard__9o+ZH","editStyle":"profile_editStyle__b7I9K","font20":"profile_font20__+OxIT"};